import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { BaseDraggableWidget } from '../Card';
import Button from '../../Button';
import { useParams } from 'react-router-dom';
import useAsync from '../../../hooks/useAsync';
import { getAssetWidgetData } from '../../../api';

const TITLE = 'Quick Setup';
const DESCRIPTION = 'Enter description here';
const CATEGORY = 'Asset';

const AssetQuickSetup = ({ title, isPreview, ...rest }) => {
	const [query, setQuery] = useState('');
	const { id } = useParams();

	const navigate = useNavigate();

	const { value: setupWidgetData } = useAsync(getAssetWidgetData, {
		defaultPayload: {
			id,
			widgetId: 'asset-quick-setup',
		},
	});

	if (isPreview) {
		return (
			<BaseDraggableWidget
				title={TITLE}
				category={CATEGORY}
				description={DESCRIPTION}
				{...rest}
				isPreview={true}
			/>
		);
	}

	return (
		<BaseDraggableWidget title={TITLE} widgetProps={{}} {...rest}>
			<div className="grid grid-cols-1 gap-y-4">
				<div className="flex justify-between items-center">
					<div className="text-gray-500">Add Preventive Maintenance</div>
					<Button type="secondary">Add</Button>
				</div>
				<div className="flex justify-between items-center">
					<div className="text-gray-500">Add Contracts</div>
					<Button type="secondary">Add</Button>
				</div>
				<div className="flex justify-between items-center">
					<div className="text-gray-500">Add Power Users</div>
					<Button type="secondary">Add</Button>
				</div>
				<div className="flex justify-between items-center">
					<div className="text-gray-500">Add Service Vendors</div>
					<Button type="secondary">Add</Button>
				</div>
			</div>
		</BaseDraggableWidget>
	);
};

export default AssetQuickSetup;
